// NewMortgageLoanForm.js
import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";


const NewCreditCardForm = () => {
    const [originationDate, setOriginationDate] = useState(null);
    const [accountNumber, setAccountNumber] = useState(null);
    const [lenderChoices, setLenderChoices] = useState([]);
    const [selectedLender, setSelectedLender] = useState('');
    const [baseRateChoices, setBaseRateChoices] = useState([]);
    const [selectedBaseRate, setSelectedBaseRate] = useState('');
    const [initialCreditLimit, setInitialCreditLimit] = useState(50000);
    const [paymentDayOfMonth, setPaymentDayOfMonth] = useState(1);
    const [transferFeePercent, setTransferFeePercent] = useState(null);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLenderChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/lender-choices/');
                setLenderChoices(response.data);
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchLenderChoices();
    }, []);

    useEffect(() => {
        const fetchBaseRateChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/rate-type-choices/');
                setBaseRateChoices(response.data);
            } catch (error) {
                console.error('Error fetching interest rate type choices:', error);
                setError('Failed to fetch interest rate type choices.');
            }
        };
        fetchBaseRateChoices();
    }, []);

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newCreditCardData = {
            'origination_date': originationDate,
            'account_number': accountNumber,
            'revolver_type': 'credit_card',
            'lender': selectedLender,
            'base_rate_type': selectedBaseRate,
            'credit_limit': initialCreditLimit,
            'credit_limit_date': originationDate,
            'payment_day_of_month': paymentDayOfMonth,
            'transfer_fee_percent': transferFeePercent,
        }

        // if (titleDocument) {
        //     newCreditCardData.append('title_document', titleDocument);
        // }
        console.log('New Credit Card Data:', newCreditCardData)
        try {
            const response = await axios.post('/api/balance_sheet/financing/revolvers/credit-cards/', newCreditCardData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate(`/balance_sheet/financing/revolvers/credit-cards/${response.data.id}/`);


            // Now you can toggle visibility for land and structure forms
        } catch (error) {
            console.error('Error creating credit card:', error);
            setError('There was an error creating the credit card. Please check your input.');
        }
    };

  return (
        <div className="container mt-4" style={{margin: 0, padding: '20px', maxWidth: '70%'}}>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="lender" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Lender:</label>
                    <select
                        id="lender"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedLender}
                        onChange={(e) => setSelectedLender(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a lender</option>
                        {lenderChoices.map(([id, name]) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Card Number:</label>
                    <input
                        type="number"
                        value={accountNumber}
                        onChange={(e) => setAccountNumber(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Credit Limit:</label>
                    <input
                        type="number"
                        value={initialCreditLimit}
                        onChange={(e) => setInitialCreditLimit(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                      <label htmlFor="baseRate" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Base Rate Type:</label>
                      <select
                        id="baseRateType"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedBaseRate}
                        onChange={(e) => setSelectedBaseRate(e.target.value)}
                        required
                      >
                        <option value="prime">Prime</option>
                        <option value="treasury_10_yr">10 Yr. Treasury</option>
                      </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Origination Date:</label>
                    <input
                        type="date"
                        value={originationDate}
                        onChange={(e) => setOriginationDate(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Payment Day of Month:</label>
                    <input
                        type="number"
                        value={paymentDayOfMonth}
                        onChange={(e) => setPaymentDayOfMonth(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>Transfer Fee Percent:</label>
                    <input
                        type="number"
                        value={transferFeePercent}
                        onChange={(e) => setTransferFeePercent(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

            <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
            </form>

            {error && <div className="text-danger">{error}</div>} {/* Display error messages */}
        </div>
    );
};
export default NewCreditCardForm;